import { render } from "./lorry_wise_sale_details.vue?vue&type=template&id=b37fa7e6&scoped=true"
import script from "./lorry_wise_sale_details.vue?vue&type=script&lang=js"
export * from "./lorry_wise_sale_details.vue?vue&type=script&lang=js"

import "./lorry_wise_sale_details.vue?vue&type=style&index=0&id=b37fa7e6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37fa7e6"]])

export default __exports__